import React, { PureComponent, useContext } from 'react';
import PropTypes from 'prop-types';
import { ATTACHMENTS } from 'newJs/config';

const { CLICK_ACTIONS: { SAVE_TO_FILES_ALL }} = ATTACHMENTS;

const AttachDataContext = React.createContext({
    extension: '',
    hashId: SAVE_TO_FILES_ALL // Used to detect this action
});

const withAttachData = (Component) => {
    class ComponentWithData extends PureComponent {
        render() {
            return (
                <AttachDataContext.Consumer>
                    {(data) => <Component data={data} />}
                </AttachDataContext.Consumer>
            );
        }
    }

    return ComponentWithData;
};

const AttachDataProvider = ({ children, value }) => (
    <AttachDataContext.Provider value={value}>
        {children}
    </AttachDataContext.Provider>
);

AttachDataProvider.propTypes = {
    children: PropTypes.node.isRequired,
    value: PropTypes.object,
};

const useAttachData = () => {
    const context = useContext(AttachDataContext);

    if (context === undefined) {
        throw new Error('useAttachData must be used within AttachDataProvider');
    }
    return context;
};

export { useAttachData, AttachDataContext, withAttachData };
export default AttachDataProvider;
